import { PropsWithChildren, useEffect } from 'react'

import { useEInvoicingSetup } from '../../hooks/useEInvoicingSetup'
import { EInvoicingSetupStep } from '../../types'

interface EInvoicingNavigationWrapperProps {
  step: EInvoicingSetupStep
}

export const EInvoicingNavigationWrapper = ({ children }: PropsWithChildren<EInvoicingNavigationWrapperProps>) => {
  const { restartFlow, kycAttemptId } = useEInvoicingSetup()

  useEffect(() => {
    if (!kycAttemptId) {
      restartFlow()
    }
  }, [kycAttemptId, restartFlow])

  if (!kycAttemptId) {
    return null
  }

  return children
}
